import { Component, OnInit } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';


@Component({
  selector: 'app-manage-circle-city',
  templateUrl: './manage-circle-city.component.html',
  styleUrls: ['./manage-circle-city.component.css']
})
export class ManageCircleCityComponent implements OnInit {
  circleCities=[];
  constructor(private leadapi:LeadsService,private sharedapi:SharedService) { 
    this.getcirclecities();
  }

  ngOnInit(): void {
  }

  async getcirclecities()
  {
      await this.leadapi.getcirclescities().subscribe((data:any) => {
          if(data.status)
          {
            this.circleCities = data.data;
          }else{
              this.circleCities = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }
}
